export function initialize() {
    console.log("Initializing scroll to target with href");

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const attributeValue = String(this.getAttribute('href'));
            if (attributeValue.startsWith(`#`)) {
                e.preventDefault();
                const target = document.querySelector(attributeValue);

                if (target) {
                    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = targetPosition - 80;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
                else {
                    console.warn("Target not found. Unable to scroll to target. Maybe was only '#' written?");
                }
            }
            else {
                console.warn(`Target doesn't contains anymore #'`)
            }
            
        });
    });

    console.log("Scroll to target with href initialized");
}